import Modal from "react-modal";
import { Table, Row, Col, Card, CardBody, Container } from 'reactstrap';
import Image from "./Image";
import { useState } from "react";
import { updateProduct } from "../API/Backend";
import { showToast } from "./Toast";
import Skeleton from "react-loading-skeleton";
Modal.setAppElement("#root");

export const CarrefourModal = ({ visible, onClose, item,loading }) => {

    const [selectedId, setSelectedId] = useState(null);
    const handleCheckboxChange = (id) => {
        setSelectedId(id);
    };

    const onUpdateProduct = (item) => {

        let fiter = item.filter(i => i.item.title === selectedId);

        let formData = {
            carrefourPrice: fiter[0].item.price,
            carrefourLink: fiter[0].item.link,
            lastCarrefourUpdate: new Date(),
        }

        updateProduct(formData, fiter[0]._id).then((data) => {
            if (data.data.success) {
                showToast("success", "Products Updated", "Products has been updated successfully.")
                onClose(fiter[0].item);
            }
            else {
                showToast("error", "Products Request Failed", "Products could not be updated.")
                onClose(fiter[0].item);
            }
        }).catch((e) => {
            showToast("error", "Products Request Failed", "Products could not be updated.")
            onClose(fiter[0].item);
        })
    };

    if (!visible) return null; // don’t render if hidden
    return (

        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            contentLabel="Product Details"
            style={{
                overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
                content: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    transform: "translate(-50%, -50%)",
                    width: "1400px",
                    borderRadius: "10px",
                    padding: "20px",
                    overflow: "hidden"
                },
            }}
        >
            <button className='btn btn-rounded btn-outline-secondary mb-3' style={{ float: "right" }} onClick={onClose}>X</button>
            <Table>
                <thead>
                    <tr>
                        <th className='w-20'>Image</th>
                        <th className='w-50'>Product</th>
                        <th className='w-15'>Price</th>
                        <th className='w-15'></th>
                        <th className='w-15'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ?
                            [...Array(5)].map((a, i) => {
                                return <tr key={i}>
                                    <td className='w-20'><div><Skeleton height={40} width={80} className='me-2' /></div></td>
                                    <td className='w-50'><Skeleton height={12} width={80} /></td>
                                    <td className='w-15'><Skeleton height={20} width={60} /></td>
                                    <td className='w-15'><Skeleton height={30} width={60} /></td>
                                    <td className='w-15'><Skeleton height={30} width={60} /></td>
                                </tr>
                            }) :
                            item.length == 0  ?
                                <tr><td colSpan="5" className="text-center fs-12 fw-600"><span className="d-flex align-items-center justify-content-center"><i className="ri-error-warning-line text-danger fs-22 fw-300 me-2"></i> No products found</span></td></tr> :

                                item.map((d, i) => (
                                    <tr key={i}>
                                        <td className='w-20'><Image src={d.item.image} alt="Banner" className='me-2' height='70px' width='120px' objectFit='cover' /></td>
                                        <td className='w-50'>{d.item.title}</td>
                                        <td className='w-15'><a href={d.item.price} target='_blank' className='text-dark text-decoration-none'><strong>$ {d.item.price}/-</strong></a></td>
                                        <td className="w-15">
                                            {d.item.isBestMatch && (
                                                <button className='btn btn-rounded btn-outline-secondary' style={{ backgroundColor: '#d4edda', color: '#155724', borderColor: '#c3e6cb' }}>
                                                    {d.item.isBestMatch ? 'Best Match' : ''}</button>)}
                                        </td>
                                        <td className='w-15'>

                                            <input
                                                type="checkbox"
                                                checked={selectedId === d.item.title}
                                                onChange={() => handleCheckboxChange(d.item.title)}
                                            />
                                        </td>
                                        {/* <td>
                                  <Link className='btn btn-rounded btn-outline-secondary btn-small' onClick={() => openModal(item)}><i className="ri-edit-line"></i> Get Carrefour Products</Link>
                                </td> */}
                                    </tr>
                                ))
                    }
                </tbody>
            </Table>
            <button className='btn btn-rounded btn-outline-secondary' style={{ float: "right" }} disabled={!item} onClick={() => onUpdateProduct(item)}>Submit</button>
        </Modal>
    );
}